<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`车辆行驶里程详情`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "行驶里程详情" },
      ],
      baseUrl: 'car',
      getListUrl: 'getmileage',
      formInline: {},
      formCtrl: [
        {
          label: "日期",
          keyName: "date",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "date", label: "日期", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        // { keyName: "trailer", label: "挂车号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名" },
        // { keyName: "escort", label: "押运员" },
        { keyName: "mileage", label: "里程", minwidth: 120 },
      ],
      baseParams: ['license'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    setParams() {
      const { license } = this.$route.query
      // console.log(this.$route)
      // console.log(license)
      this.formInline.license = license
      // console.log({...this.formInline})
      this.getList()
    },
  },
  mounted() {
    this.page = 1
    this.formInline = {}
    // console.log({...this.formInline})
    this.$nextTick(this.setParams)
  },
};
</script>
<style lang="less" scoped>
</style>